import { render, staticRenderFns } from "./CurrenciesAutocomplete.vue?vue&type=template&id=0a6fd71e&scoped=true&"
import script from "./CurrenciesAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CurrenciesAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./CurrenciesAutocomplete.vue?vue&type=style&index=0&id=0a6fd71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6fd71e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6fd71e')) {
      api.createRecord('0a6fd71e', component.options)
    } else {
      api.reload('0a6fd71e', component.options)
    }
    module.hot.accept("./CurrenciesAutocomplete.vue?vue&type=template&id=0a6fd71e&scoped=true&", function () {
      api.rerender('0a6fd71e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Autocomplete/CurrenciesAutocomplete.vue"
export default component.exports